export default {
    methods: {
        downloadChart() {
            const link = this.$refs.downloadUrl;
            link.download = `chart-${Math.round(Math.random() * 100000)}.png`;
            link.href = this.chart.canvas.toDataURL('image/png');
            link.click();
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/exportChart.js